<template>
    <div class="link-markdown">
        <div class="link-markdown-slot">
            <slot></slot>
        </div>
        <div class="link-markdown-wrapper">
            <link-collapse :title="title" v-model="lv_show" disabledClickHead @clickHead="()=>!!lv_show?close():open()">
                <div class="link-markdown-content">
                    <div v-html="!!md&&!!html?md.render(html):null"></div>
                    <div v-html="!!md&&!!scss?md.render(scss):null"></div>
                    <div v-html="!!md&&!!js?md.render(js):null"></div>
                    <div v-html="!!md&&!!lv_markdown?md.render(lv_markdown):null"></div>

                    <div class="link-markdown-wrapper-collapse-button" @click="lv_show=false">
                        <link-icon icon="link-icon-up"/>
                    </div>
                </div>
            </link-collapse>
        </div>
    </div>
</template>

<script>

    let md = null;

    export default {
        name: "link-markdown",
        props: {
            markdown: {type: String},                                       //markdonw文件地址
            html: {type: String},                                           //Html代码
            js: {type: String},                                             //JavaScript代码
            scss: {type: String},                                            //Css代码
            show: {type: Boolean, default: false},                          //是否默认展开
            title: {type: String, default: '查看代码'},                      //折叠标题
            initialized: {type: Boolean, default: false},                   //是否初始化的时候就初始化内容


        },
        data() {
            return {
                lv_markdown: null,
                lv_show: this.show,
                lv_initialized: this.show || this.initialized,
                md,
            }
        },
        async created() {
            // !!this.lv_initialized && (await this.lv_init())
        },
        computed: {
            val() {
                let md = '';
                !!this.html && (md = md + '```html ' + this.html + '\n```\n')
                !!this.js && (md = md + '```javascript ' + this.js + '\n```\n')
                !!this.scss && (md = md + '```scss ' + this.scss + '\n```\n')
                !!this.lv_markdown && (md += this.lv_markdown)
                return md
            },
        },
        methods: {
            async open() {
                const next = () => this.$nextTick(() => this.lv_show = true)
                if (!this.lv_initialized) await this.lv_init(next)
                else next()
            },
            close() {
                this.lv_show = false
            },
            async lv_init(next) {
                if (!md) {
                    const MarkdownIt = await this.lv_initMarkdownIt()
                    this.md = md = MarkdownIt()
                }
                if (!!this.markdown) {
                    /*import('src/assets/markdown/' + this.markdown + '.md').then((val) => {
                        this.lv_markdown = val
                        this.lv_initialized = true
                        this.$nextTick(() => !!next && next())
                    })*/
                } else {
                    this.lv_initialized = true
                    this.$nextTick(() => !!next && next())
                }
            },
            lv_initMarkdownIt() {
                // return new Promise((rs, rj) => import('markdown-it').then(module => rs(module)).catch(rj))
            },
        },
    }
</script>

<style lang="scss">
    .link-markdown {
        .link-markdown-wrapper {
            width: 100%;
            box-sizing: border-box;
            padding: 0 32px;
            .link-markdown-wrapper-collapse-button {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 32px;
                width: 100%;
                cursor: pointer;
                background-color: white;
            }
        }

        .editormd-preview, .editormd {
            height: max-content !important;
            position: initial !important;
        }
    }
</style>
